import { Order, OrderType } from './order';
import OrderInfoDetail from '../order-info.interface';

export class OrderEthernet extends Order {

	constructor()	{
		super();
		this.type = OrderType.ETHERNET;
	}

	public getRowInfo(): OrderInfoDetail[] {
		return [
			{
				title: 'Vendor/Access Provider',
				value: this.vendor_name,
			},
			{
				title: 'Vendor Circuit ID',
				value: this.vendor_circuit_id,
			},
			{
				title: 'FOC Date',
				value: this.formatDate(this.foc_date),
			},
			{
				title: 'Equipment Tracking Number',
				value: this.tracking_number,
			},
			{
				title: 'Customer Connector Type',
				value: this.customer_handoff,
			},
			{
				title: 'Last Mile Provider Circuit ID',
				value: this.last_mile_circuit_id,
			},
			{
				title: 'Start of Service Date',
				value: this.formatDate(this.start_service),
			},
			{
				title: 'Order Date',
				value: this.formatDate(this.order_date),
			},
			{
				title: 'Equipment Shipping Address',
				value: this.shipping_address,
			},
		];
	}

}
